'use client';

import { cn } from "@theme/utils";
import { useState } from "react";

type Props = {
  content: string;
  title?: string;
}

export const CategorySeo = (props: Props) => {
  const { content, title } = props;
  const [isMore, setIsMore] = useState(false);

  if (!content && !title) return;

  return (
    <>
      <div className='container px-2 mb-5 w-full'>
        <div className="relative">
          {title && <h1 className="text-xl md:text-3xl font-bold mb-4">{title}</h1>}
          <div
            className={cn(
              "text-xs list-page-seo-description",
              isMore ? 'h-auto' : 'h-[100px] overflow-hidden'
            )}
            style={{
              backgroundImage: !isMore && 'linear-gradient(to bottom, #000, rgba(0, 0, 0, 0) 103%)',
              WebkitTextFillColor: !isMore && 'transparent',
              backgroundClip: !isMore && 'text'
            }}
            dangerouslySetInnerHTML={{ __html: content }}
          />

        </div>
        <div
          onClick={() => setIsMore(!isMore)}
          className="cursor-pointer text-sm font-medium"
        >
          {isMore ? 'Devamını gizle' : 'Devamını gör'}
        </div>
      </div>
    </>
  )
}
